"use client";

import { TextType, Typography, TypographyProps } from "@components/atoms/typography/typography";
import { APP_NS } from "i18n";
import { useTranslation } from "react-i18next";

const captionClasses =
    "min-w-0 max-w-full break-words hyphens-auto [overflow-wrap:anywhere] !text-[26px] !leading-[110%] !tracking-[-0.52px] bp-375:!text-[30px] md:!text-[48px] md:!leading-[105%] md:!tracking-[-0.96px] lg:!text-[56px] lg:!leading-[56px] lg:!tracking-[-1.12px]";

const subCaptionClasses =
    "min-w-0 max-w-full break-words hyphens-auto [overflow-wrap:anywhere] !text-[24px] !leading-[115%] !tracking-[-0.24px] bp-375:!text-[28px] md:!text-[32px] md:!leading-[36px] md:!tracking-[-0.32px]";

function useDocumentLang(): string | undefined {
    const { i18n } = useTranslation(APP_NS);
    return i18n.language?.split("-")[0];
}

export function LegalCaption({ className, ...p }: Omit<TypographyProps, "type">) {
    const lang = useDocumentLang();
    return (
        <Typography
            type={TextType.CAPTION}
            lang={lang}
            className={`${captionClasses} ${className ?? ""}`}
            {...p}
        />
    );
}

export function LegalSubCaption({ className, ...p }: Omit<TypographyProps, "type">) {
    const lang = useDocumentLang();
    return (
        <Typography
            type={TextType.SUB_CAPTION}
            lang={lang}
            className={`${subCaptionClasses} ${className ?? ""}`}
            {...p}
        />
    );
}
